<template>
  <el-row>
        <el-col>
            <el-table :data="locusdData" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column prop="id" label="单号" sortable width="140">
                </el-table-column>
                <el-table-column prop="sqrq" label="时间" sortable :formatter="formateTime">
                </el-table-column>
                <el-table-column prop="dblx" label="事件" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.dblx=='0'">调拨</span>
                        <span v-if="scope.row.dblx=='1'">调入</span>
                        <span v-if="scope.row.dblx=='2'">调出</span>
                    </template>
                </el-table-column>
                <el-table-column prop="drdw" label="调入单位"  width="200">
                </el-table-column>
                <el-table-column prop="dcdw" label="调出单位"  width="200">
                </el-table-column>
                <el-table-column prop="userName" label="发起人" >
                </el-table-column>
                <el-table-column  label="操作" >
                    <template slot-scope="scope">
                        <el-link :underline="false"  style="color: #4095E5;text-decoration: none;" @click="toAllactionDetail(scope.row)">详情 </el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>

        <!--分页工具条-->
        <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
            <el-pagination v-if="locusdData.length > 0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="[5]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
            </el-pagination>
        </el-col>
    </el-row>
</template>
<script>
import { selectAllactionByDeviceId } from '../../../api/api'
export default {
    data() {
        return {
            pagesize:5,
            pageIndex: 1,
            total:4,
            locusdData: []
        }
    },
    props: {
        deviceinfo: {
            default: {}
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.pageIndex = val;
        //     //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
        //     //.slice()方法接受两个参数，开始和结束的值
        //     //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
           this.getLocusdData();
        },
        handleSizeChange(val) {
            this.pagesize = val;
           this.getLocusdData();
        },
        getLocusdData(){
            let _params={
                deviceId:JSON.parse(sessionStorage.getItem("deviceinfoDetail")).id,
                pageIndex:this.pageIndex,
                pagesize:this.pagesize
            }
            selectAllactionByDeviceId(_params).then(datas=>{
                let {status,data} = datas
                if(status==200){
                    this.locusdData=data.list
                    this.total=data.total
                }
            })
        },
        toAllactionDetail(row){
            sessionStorage.setItem("allocationData",JSON.stringify(row))
            let userinfo=JSON.parse(localStorage.getItem("user")) 
            let userRoles=userinfo.role.menuId
            if(userRoles.indexOf("160")==-1){
                this.$message({message: "你没有权限访问该页面",type: 'warning'});
            }else{
                this.$router.push({
                    path: "/allocation"
                });
            }
        },
         // 格式化时间显示到日期
        formateTime(row) {
            let nowData = new Date(row.sqrq)
            let year = nowData.getFullYear();
            let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
            let date = nowData.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${date}`;
         },
        
        
    },
    created() {
        this.getLocusdData();
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/device/components/DeviceLocus.vue